module.exports = __webpack_public_path__ + "static/media/HelpAI3.63f45786.jpg";